// @core/api/endpoints/authz/write_authorization_model.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  WriteAuthorizationModelRequest,
  WriteAuthorizationModelResponse,
} from '../../../types/authz';

const BASE_PATH = '/authz';

/**
 * Create authorization model
 * Creates a new authorization model version from the provided DSL schema. This does not delete existing tuples; they remain valid under the new model. Use this to update type definitions and relations.
 */
export async function WriteAuthorizationModel(
  data: WriteAuthorizationModelRequest,
  options?: RequestOptions
): Promise<WriteAuthorizationModelResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/models`;
  const requestOptions = options;
  return client.post<WriteAuthorizationModelResponse>(requestPath, data, requestOptions);
}
